
import React, { useEffect } from 'react';
import { ResourcesContext } from './ResourcesContext';
import { defaultCategories, defaultResources } from '../data/mockData';
import { useResourceManager } from '../hooks/useResourceManager';
import { checkStorageVersion, LOCAL_STORAGE_KEYS } from '../utils/storageUtils';

export const ResourcesProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useEffect(() => {
    const versionIsCurrent = checkStorageVersion();
    if (!versionIsCurrent) {
      // Clear stored data and use fresh default data if version has changed
      localStorage.removeItem(LOCAL_STORAGE_KEYS.RESOURCES);
      localStorage.removeItem(LOCAL_STORAGE_KEYS.CATEGORIES);
      localStorage.setItem(LOCAL_STORAGE_KEYS.CATEGORIES, JSON.stringify(defaultCategories));
      localStorage.setItem(LOCAL_STORAGE_KEYS.RESOURCES, JSON.stringify(defaultResources));
    }
  }, []);

  // Use the resource manager hook to handle all state and functionality
  const resourceManager = useResourceManager(defaultCategories, defaultResources);
  
  return (
    <ResourcesContext.Provider value={resourceManager}>
      {children}
    </ResourcesContext.Provider>
  );
};
